import React, {useCallback} from 'react';
import {useStores} from "../../stores";
import {observer} from "mobx-react-lite";
import type {Option, SelectionResult} from "../../components/visualization/api-dropdown-filter/ApiDropdownTypes";
import type {PageResponse} from "../../services/ApiTypes";
import {
    ApiDropdownFilterComponent,
    DEFAULT
} from "../../components/visualization/api-dropdown-filter/ApiDropdownFilterComponent";

type Selection = SelectionResult<number>;
export const SearchGeoRegionAutocomplete: React.FC = observer(() => {
    const {p, bagStore, materializedApi} = useStores();
    const selection: Selection = bagStore.advanced.filters.geo_regions || DEFAULT;
    const filter = bagStore.advanced.filterQueryParamsGeoRegions;

    const getOptions = useCallback(
        search => (bagStore.advanced.databagId && bagStore.advanced.ready) ? materializedApi.searchInsightGeoRegions(bagStore.advanced.databagId, filter, search)
            .then<PageResponse<Option>>(resp => ({
                count: resp.data.length,
                next: '',
                previous: '',
                results: resp.data.map(obj => ({
                    id: String(obj.id),
                    label: obj.region_long || 'Unknown',
                    subLabel: obj.country_name ?? '',
                    subTotalSpend: Number(obj.total_spend),
                    obj,
                }))
            })) : null,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [bagStore.advanced.databagId, bagStore.advanced.ready, filter]
    );

    if (!bagStore.advanced.ready) return <></>;
    return <ApiDropdownFilterComponent
        selection={selection}
        label={p.regionDataLabel}
        enableLabelStatus
        getOptions={getOptions}
        showOptionSubLabel
        onSelectionChange={selection => bagStore.advanced.geoRegionFilterChanged(selection as Selection)}
        buttonProps={{fullWidth: true, sx: {height: '100%'}}}
    />
})
